module.exports = __webpack_public_path__ + "static/media/Group.6277380d.svg";